<ui-title [title]="'Approval Request'"></ui-title>

<ui-loading [loading]="ar.loading"></ui-loading>

<ui-alert
	*ngIf="modalAlert.display"
	[title]="modalAlert.title"
	[text]="modalAlert.text"
	(onAction)="modalAlert.cb($event)"
></ui-alert>
<div *ngIf="!ar.loading">
	<div class="card">
		<div class="card-header">
			Request Info
		</div>
		<div class="card-body">
			<div class="row">
				<label class="col-lg-3 font-weight-bold">Type</label>
				<div class="col-lg-8">{{ar.data.Type}}</div>
			</div>
			<div class="row">
				<label class="col-lg-3 font-weight-bold">Reference</label>
				<div class="col-lg-8">{{ar.data.Reference}}</div>
			</div>

			<div class="row">
				<label class="col-lg-3 font-weight-bold">Created</label>
				<div class="col-lg-8">{{ar.data.CreatedDate|date}}</div>
			</div>

			<div class="row">
				<label class="col-lg-3 font-weight-bold">Approver</label>
				<div class="col-lg-8">{{ar.data.SORUser.FirstName}} {{ar.data.SORUser.LastName}} {{ar.data.SORUser.Email}}</div>
			</div>

		</div>
	</div>
	<div class="card-separator"></div>

	<div class="card">
		<div class="card-header">
			Request
		</div>
		<div class="card-body">
			<p>
				{{ar.data.Description}}
			</p>


			<div *ngIf="ar.data.Filepath">
				<button class="btn btn-primary btn-sm" (click)="ar_downloadFile()">Download file</button>
			</div>
		</div>

	</div>


	<div class="card-separator"></div>
	<ui-loading [loading]="ar.saving"></ui-loading>
	<div class="card" [hidden]="ar.saving">
		<div class="card-header">
			Decision
		</div>
		<div class="card-body">
			<div class="form-group mb-3" *ngIf="ar.data.DecisionDate">
				<label class="col-form-label">
					Decision Taken
				</label>
				<div>
					{{ar.data.DecisionDate|date}}
				</div>
			</div>


			<div class="form-group mb-3">
				<label class="col-form-label">
					Comments
				</label>
				<div>
					<textarea [readOnly]="!ar.canApprove" name="aqcomments" class="{{!ar.canApprove?'cursor-forbidden':''}} form-control" type="text" [maxLength]="255" [(ngModel)]="ar.data.Comments"></textarea>
				</div>
			</div>

			<div class="form-group mb-3">
				<label class="col-form-label">
					Attachments
				</label>
				<div>
					<ui-uploader [listVisible]="ar.uploaded.length>0" [files]="ar.uploaded" [readOnly]="!ar.canApprove" [parent]="self"></ui-uploader>
				</div>
			</div>

			<div class="form-group mb-3">
				<label class="col-form-label">
					Decision
				</label>
				<div>
					<ng-container *ngFor="let b of ar.buttons">
						<button (click)="ar_onDecisionChange(b)" type="button"
								class="{{!ar.canApprove?'cursor-forbidden':''}} btn btn-sm btn-{{ar.decision == b.status?b.cssClass:'default-important'}}">
							{{ar_button_label(b.status)}}</button>
						&nbsp;
					</ng-container>
				</div>
			</div>

			<div class="form-group mb-3" *ngIf="ar.data.NeedCountersigning && ar.data.StatusId!='pending'">
				<label class="col-form-label">
					Counter Signing
				</label>
				<br>
				<div>
					<input placeholder="Comments" [readOnly]="!ar.canCounterSign" name="csComments"
						   class="{{!ar.canCounterSign?'cursor-forbidden':''}} form-control" type="text" [maxLength]="255" [(ngModel)]="ar.data.CounterSigningComments"/>
				</div>
				<br>
				<div>
					<button (click)="ar_counterSign()" type="button" class="{{!ar.canCounterSign?'cursor-forbidden':''}} btn btn-sm btn-{{ar.data.CounterSignedBy?'success white-important':'default-important'}}">Counter Sign</button>
				</div>

				<p *ngIf="ar.data.CounterSignedDate">counter signed on the {{ar.data.CounterSignedDate|date}} by {{ar.data.CounterSignedBy}}</p>
			</div>
		</div>
	</div>

	<div class="card-separator"></div>
	<div class="card" [hidden]="ar.saving">
		<div class="card-header">
			Admin Tools
		</div>
		<div class="card-header">
			<button (click)="ar_cancel()" *ngIf="ar.data.StatusId!='cancelled'" type="button" class="{{!ar.canCancelReassign?'cursor-forbidden':''}} btn btn-danger">Cancel</button>&nbsp;
			<button (click)="ar_reInstate()" *ngIf="ar.data.StatusId=='cancelled'" type="button" class="{{!ar.canCancelReassign?'cursor-forbidden':''}} btn btn-warning">Reinstate</button>&nbsp;
			<button (click)="ar_reAssign()" *ngIf="ar.data.StatusId!='cancelled'" type="button" class="{{!ar.canCancelReassign?'cursor-forbidden':''}} btn btn-primary">Re-assign</button>
			( status is : {{ar.data.StatusId}} )
		</div>
	</div>
</div>


<ui-modal [(isHidden)]="reAssign.modalHidden" class="modal-sm" [title]="ar.data.Type" [lg]="true">
	<form>
		<div class="form-group mb-3">
			<label class="col-form-label">
				User list
			</label>
			<div>
				<ui-input-autocompleter
					#autocompleter
					[text]="'Search User'"
					[controller]="self"
					[autocompleteDisplay]="helper_autocomplete_displaySelectedUsername"
					[searchObservable]="helper_autocomplete_search"
				></ui-input-autocompleter>
			</div>
		</div>
		<div class="form-group mt-3">
			<button class="btn btn-primary" (click)="reassignApprovalRequest()">
				Assign
			</button>
		</div>

	</form>
</ui-modal>
